export default "__VITE_ASSET__DYJzbaKy__"